import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { Grid } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from '@material-ui/core';

import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { withStyles } from '@material-ui/core/styles';

const StyledTableCell = withStyles((theme) => ({
    body: {
        fontSize: 16,
        fontWeight: 'bold'
    }
}))(TableCell);
const ValueTableCell = withStyles((theme) => ({
    body: {
        fontSize: 16,
        fontWeight: 'bold',
        color: 'green'
    }
}))(TableCell);

export function SearchByAccountNumber({
    isOpen,
    title,
    request,
    activeDMTName,
    negativeButtonTitle,
    negativeButtonClick
}) {
    const [open, setOpen] = useState(isOpen);
    const classes = commonStyle();

    const handleNegativeButtonClick = () => {
        setOpen(false);
        negativeButtonClick(request);
    };

    if (isOpen === undefined || isOpen === null || isOpen === false) {
        return null;
    }

    return (
        <Dialog
            fullWidth
            maxWidth="md"
            open={open}
            onClose={() => {
                setOpen(false);
                negativeButtonClick(false);
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title" className={classes.title}>
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="DialogPrint">
                    <SenderByAccountNumber
                        request={request}
                        activeDMTName={activeDMTName}
                        setOpen={(value) => {
                            setOpen(false);
                            // request.Mobile = value;
                            negativeButtonClick(false);
                        }}
                    />
                </DialogContentText>
            </DialogContent>
            <DialogActions displayPrint="none">
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={6} lg={6}></Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Button
                            onClick={handleNegativeButtonClick}
                            className={classes.CustomSecondaryButtonStylePopup}
                        >
                            {negativeButtonTitle ? negativeButtonTitle : 'Ok'}
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    );
}

const SenderByAccountNumber = ({ request, activeDMTName, setOpen }) => {
    let data = request;
    const classes = commonStyle();
    const history = useHistory();
    return (
        <Grid item xs={12}>
            <Grid item xs={12}>
                <TableContainer>
                    <Table aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="left">
                                    Sender Name
                                </StyledTableCell>
                                <StyledTableCell align="left">
                                    Sender Number
                                </StyledTableCell>
                                <StyledTableCell align="left"></StyledTableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {data.map((d, index) => (
                                <TableRow key={index}>
                                    <ValueTableCell>
                                        {d.SenderName}
                                    </ValueTableCell>
                                    <ValueTableCell align="left">
                                        {d.SenderNumber}
                                    </ValueTableCell>
                                    <ValueTableCell align="left">
                                        <Button
                                            type="submit"
                                            title="Add"
                                            className={
                                                classes.CustomPrimaryButtonStyle
                                            }
                                            onClick={(e) => {
                                                var param = {
                                                    Mobile: d.SenderNumber,
                                                    ActiveDMTName: activeDMTName
                                                };
                                                history.push(
                                                    '/C_SenderSearch',
                                                    param
                                                );
                                            }}
                                        >
                                            Proceed
                                        </Button>
                                    </ValueTableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </Grid>
    );
};
